import generateRender from '../generateRender';
export var getDefaultCountryValue = generateRender({
  default: 'US',
  admiral: 'AT',
  admes: 'ES'
});